import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import MuiCircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
export const CircularProgress = () => {
    return (_jsx(Box, { sx: { display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }, children: _jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }, children: [_jsx(MuiCircularProgress, { size: 48 }), _jsx(Typography, { variant: "body2", color: "text.secondary", children: "Loading, please wait..." })] }) }));
};
